import styled from 'styled-components/macro';
import { getSplitPaymentColor } from '../splitPaymentHelpers';

type SplitPaymentDotProps = {
    index: number;
};

const SplitPaymentDot = ({ index }: SplitPaymentDotProps) => {
    const background = getSplitPaymentColor(index);
    return <BaseSplitPaymentDot background={background} />;
};

type BaseSplitPaymentDotProps = {
    background: string;
}

const BaseSplitPaymentDot = styled.div<BaseSplitPaymentDotProps>`
    width: 24px;
    height: 24px;
    border-radius: 12px;
    background: ${props => props.background};
`;

export default SplitPaymentDot;
